import { useEffect, useState } from "react";
import { Hammer, MapPin } from "lucide-react";
import { api } from "../lib/api";
import { useLang } from "../lib/i18n";
import { useAuth } from "../lib/auth";
import { useQuick } from "../components/Layout";
import { PageHeader, Section, StatusBadge, Empty, RowLink } from "../components/common";
import { PROJECT_STATUSES } from "../lib/constants";
import { fmtDate, mapsLink } from "../lib/helpers";

export default function Projects() {
  const { t, lang } = useLang();
  const { isStaff } = useAuth();
  const quick = useQuick();
  const [status, setStatus] = useState("");
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/projects", { params: { status } }).then((r) => setList(r.data)); }, [status]);
  return (
    <>
      <PageHeader title={isStaff ? t("Projects", "Proyectos") : t("My Projects", "Mis proyectos")}
        actions={isStaff && <button className="btn-primary" onClick={() => quick.openProject()} data-testid="projects-new-btn"><Hammer className="w-5 h-5" /> {t("New Project", "Nuevo proyecto")}</button>} />
      <div className="flex gap-2 overflow-x-auto mb-4">
        {[["", "All", "Todos"], ...PROJECT_STATUSES].map(([k, en, es]) => (
          <button key={k} onClick={() => setStatus(k)} data-testid={`projects-filter-${k || "all"}`} className={`btn-sm btn shrink-0 ${status === k ? "bg-slate-900 text-white" : "bg-white border border-slate-300"}`}>{lang === "es" ? es : en}</button>
        ))}
      </div>
      <Section testid="projects-list">
        {list && !list.length && <Empty text={t("No projects", "Sin proyectos")} />}
        {list?.map((p) => (
          <div key={p.id} className="flex items-center">
            <div className="flex-1 min-w-0">
              <RowLink to={`/projects/${p.id}`} testid={`project-row-${p.id}`}>
                <div className="flex-1 min-w-0">
                  <div className="font-semibold truncate">{p.name}</div>
                  <div className="text-xs text-slate-500 truncate">{p.customer_name} · {p.address}</div>
                  <div className="text-xs text-slate-400">{fmtDate(p.start_date, lang)} → {fmtDate(p.expected_completion, lang)}</div>
                </div>
                <StatusBadge status={p.status} />
              </RowLink>
            </div>
            <a href={mapsLink(p.address)} target="_blank" rel="noreferrer" className="btn-ghost btn-sm mx-1 px-2" aria-label="Directions" data-testid={`project-directions-${p.id}`}><MapPin className="w-5 h-5" /></a>
          </div>
        ))}
      </Section>
    </>
  );
}
